/**
 * Sorts an array of objects or primitives by key/value.
 *
 * @param {Array} arr - The array to sort
 * @param {string} [key] - The key to sort by (if array of objects)
 * @param {('asc'|'desc')} [order='asc'] - Sort order
 * @returns {Array} - New sorted array
 */
export const sortArray = (arr, key, order = "asc") => {
  if (!Array.isArray(arr)) return [];

  return [...arr].sort((a, b) => {
    const valA = key ? a?.[key] : a;
    const valB = key ? b?.[key] : b;

    // handle null/undefined
    if (valA == null && valB == null) return 0;
    if (valA == null) return order === "asc" ? -1 : 1;
    if (valB == null) return order === "asc" ? 1 : -1;

    // detect date
    const isDateA = valA instanceof Date || !isNaN(Date.parse(valA));
    const isDateB = valB instanceof Date || !isNaN(Date.parse(valB));

    if (isDateA && isDateB) {
      const dateA = new Date(valA).getTime();
      const dateB = new Date(valB).getTime();
      return order === "desc" ? dateB - dateA : dateA - dateB;
    }

    // detect number
    if (!isNaN(valA) && !isNaN(valB)) {
      return order === "desc" ? valB - valA : valA - valB;
    }

    // fallback: string compare
    const comparison = String(valA).localeCompare(String(valB), undefined, {
      sensitivity: "base",
    });
    return order === "desc" ? -comparison : comparison;
  });
};
